import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const SubscriptionIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Subscription</title>
    <path fillRule="evenodd" clipRule="evenodd" d="M4 10V38H44V10H4ZM40 14V15.76L24 23.76L8 15.76V14H40ZM8 34V20.24L24 28.24L40 20.24V34H8Z"/>
  </IconBase>
);
